module.exports = __webpack_public_path__ + "img/ImageCheckingDocs.5fa4a9ff.svg";